/* ==========================================================
   ADICIONA LOGO AO LADO DO NOME NO HEADER
   - Insere uma <img> antes do texto "BELLA SIRENA"
   ========================================================== */
(function () {
  'use strict';

  // === CONFIGURAÇÃO ===
  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0743/8693/1878/files/ChatGPT_Image_20_de_mai._de_2026_01_39_22.png?v=1779315285';
  var LOGO_HEIGHT = 56; // altura em pixels (ajuste se ficar muito grande/pequeno)
  var LOGO_GAP = 12;    // espaço entre logo e texto (px)

  function insertLogo() {
    if (!LOGO_URL) return;

    // Encontra o logo de texto (procura por vários seletores possíveis)
    var selectors = ['.bs-logo', '.header__heading-logo', '.logo', 'a.header__logo', '.shop-name', '[class*="header"] [class*="logo"]'];
    var logoEl = null;
    for (var i = 0; i < selectors.length; i++) {
      logoEl = document.querySelector(selectors[i]);
      if (logoEl) break;
    }
    if (!logoEl) return;
    if (logoEl.dataset.customLogoAdded === '1') return;

    // Cria a imagem da logo
    var img = document.createElement('img');
    img.src = LOGO_URL;
    img.alt = 'Bella Sirena';
    img.className = 'custom-brand-logo';
    img.style.cssText = 'height:' + LOGO_HEIGHT + 'px;width:auto;display:inline-block;vertical-align:middle;margin-right:' + LOGO_GAP + 'px;object-fit:contain;';

    // Garante que o contêiner pai vire flex pra alinhar logo + texto
    logoEl.style.display = 'inline-flex';
    logoEl.style.alignItems = 'center';
    logoEl.style.gap = LOGO_GAP + 'px';
    logoEl.style.justifyContent = 'center';

    // Insere a logo antes do texto
    logoEl.insertBefore(img, logoEl.firstChild);
    logoEl.dataset.customLogoAdded = '1';
  }

  function run() {
    try { insertLogo(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  [200, 800, 2000].forEach(function (ms) { setTimeout(run, ms); });

  var observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
